import actionKeys from './categoryGroupActionKeys';
import service from './categoryGroupService';

const categoryGroupActions = {
  getCategoryGroup(categoryId: number) {
    return {
      type: actionKeys.GET_CATEGORY_GROUP,
      payload: {
        data: { categoryId },
        promise: service.getCategoryGroup(categoryId),
      },
    };
  },
};

export default categoryGroupActions;



// WEBPACK FOOTER //
// ./src/app/common/category-group/categoryGroupActions.js